module.exports = __webpack_public_path__ + "img/4.bb6b30b2.jpg";